module.exports = __webpack_public_path__ + "static/WEB0-63e4cb617a8be64c19f0888e38f66b1f.png";